exports = module.exports = require("../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".hooper-container[data-v-bc3d1c2a]{font-size:0.8em;height:100%}@media (min-width: 768px){.hooper-container[data-v-bc3d1c2a]{width:650px;margin:0 auto}}.hooper-container[data-v-bc3d1c2a]:focus{outline:none}.top-bar[data-v-bc3d1c2a]{background-color:#2D2D2D;height:40px;text-align:center}\n", ""]);

// exports
